module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "alphabet-scroll"
  }, _vm._l((_vm.alphabet), function(letter, i) {
    return _c('li', {
      staticClass: "letter",
      style: ({
        marginBottom: _vm.margin(letter, i)
      }),
      on: {
        "click": function($event) {
          _vm.context.$scrollTo(i)
        }
      }
    }, [_vm._v("\n        " + _vm._s(letter.letter) + "\n    ")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96e17fb0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AlbhabetScroll.vue
// module id = 588
// module chunks = 0